module.exports = __webpack_public_path__ + "img/85.ba405d31.jpg";